<template>
  <div class="contact-form">
    <h5 class="text-uppercase mb-3">{{ $t('heading') }}</h5>
    <b-form @submit.prevent="onSubmit" @reset="onReset" v-if="!sent">
      <b-form-group id="contactemailgroup">
        <b-form-input
          id="contactemail"
          @input="$v.form.email.$touch()"
          type="email"
          v-model="form.email"
          :state="emailValidation"
          aria-describedby="contactemailLiveFeedback"
          :placeholder="$_t('KW:email')"
          class="input-item"
          @focus="formInteractionDone = true"
        />
        <b-form-invalid-feedback v-if="$v.form.email.$error && $v.form.email.$dirty" id="contactemailLiveFeedback">{{
          $t('validationMessage')
        }}</b-form-invalid-feedback>
      </b-form-group>
      <b-form-group id="contactnamegroup">
        <b-form-input
          id="contactname"
          type="text"
          @input="$v.form.name.$touch()"
          v-model="form.name"
          :state="textValidation"
          aria-describedby="contactnamelLiveFeedback"
          :placeholder="$_t('KW:fullName')"
          class="input-item"
          @focus="formInteractionDone = true"
        />
        <b-form-invalid-feedback id="conatactnameLiveFeedback" v-if="$v.form.name.$error && $v.form.name.$dirty">{{
          $t('requiredMessage')
        }}</b-form-invalid-feedback>
      </b-form-group>
      <b-form-group id="contactmessagegroup">
        <b-form-textarea
          id="contacttmessage"
          :state="textValidation"
          v-model="form.message"
          :rows="3"
          @input="$v.form.message.$touch()"
          aria-describedby="contactmessagelLiveFeedback"
          :placeholder="$_t('KW:message')"
          class="textarea-item"
          @focus="formInteractionDone = true"
        ></b-form-textarea>
        <b-form-invalid-feedback id="conatactmessageLiveFeedback">{{ $t('requiredMessage') }}</b-form-invalid-feedback>
        <b-form-group>
          <br />
          <vue-recaptcha
            :sitekey="captcha_sitekey"
            :loadRecaptchaScript="true"
            @input="$v.form.captcha.$touch()"
            v-model="form.captcha"
            @verify="verifyCaptcha"
          ></vue-recaptcha>
        </b-form-group>
      </b-form-group>
      <b-button variant="outline-secondary" type="submit" class="px-4 py-2" pill :disabled="$v.form.$invalid">
        <i class="fa fa-envelope"></i>
        <span class="ml-2">{{ $_t('KW:send') }}</span>
      </b-button>
    </b-form>
    <strong class="text-secondary" v-else>{{ $t('successMessage') }}</strong>
  </div>
</template>
<script>
import { validationMixin } from 'vuelidate';
import { required, email } from 'vuelidate/lib/validators';
import VueRecaptcha from 'vue-recaptcha';

export default {
  name: 'ContactForm',
  components: { VueRecaptcha },
  i18nOptions: {
    namespaces: 'components',
    keyPrefix: 'contactForm',
  },
  mixins: [validationMixin],
  data: function() {
    return {
      formInteractionDone: false,
      captcha_sitekey: this.$store.state.api.captcha_sitekey,
      form: {
        email: '',
        name: '',
        message: '',
        captcha: '',
      },
      sent: false,
    };
  },
  computed: {
    emailValidation: function() {
      if (!this.formInteractionDone) {
        return null;
      }
      return !this.$v.form.email.$invalid || (this.$v.form.email.$invalid && !this.$v.form.email.$dirty);
    },
    textValidation: function() {
      if (!this.formInteractionDone) {
        return null;
      }
      return !this.$v.form.message.$invalid || (this.$v.form.message.$invalid && !this.$v.form.message.$dirty);
    },
  },
  validations: {
    form: {
      email: { required, email },
      name: { required },
      message: { required },
      captcha: { required },
    },
  },
  methods: {
    foo: function() {
      console.log('@input email');
    },
    onSubmit: function() {
      this.sent = false;
      this.$http
        .post('/api/contact', this.form)
        .then(response => {
          this.sent = true;
          console.log(response);
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    onReset: function() {},
    verifyCaptcha: function() {
      this.form.captcha = true;
    },
  },
};
</script>
<style lang="scss" scoped>
h5 {
  color: $primary;
  font-weight: 900;
}
.input-item:placeholder-shown,
.textarea-item:placeholder-shown {
  background: transparent;
  border-radius: 10px;
  &::placeholder {
    color: #c2c0c0;
  }
}
.input-item,
.textarea-item {
  background: #fff;
  border-radius: 10px;
}
button {
  color: $primary;
}
</style>
